
import { getActiveLanguage } from 'react-localize-redux';
import store from '../Store'
import { api } from '../services/redux-beesConfig';
import AuthService from './AuthService';
const userID = AuthService.getUserID();

class FexesService {
  static getSentFaxes(productId) {
    return api.getSentFaxes({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId })
      .then(res => res)
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
        console.log(error);
      });
  }
}
export default FexesService;



// WEBPACK FOOTER //
// ./src/services/FaxService.js